// extracted by mini-css-extract-plugin
export default {"imperialOfficials":"imperial-officials_imperialOfficials__IBqya","imperialOfficialIcon":"imperial-officials_imperialOfficialIcon__3FJ+R"};